import React from "react";
import docImg from "../../assets/images/homeSection4.svg";
import nha from "../../assets/images/nha.svg";
import aamca from "../../assets/images/amca.svg";
import msa from "../../assets/images/msa.png";
import ptc from "../../assets/images/ptc.svg";
import { useNavigate } from "react-router-dom";

function Section4() {
  const navigation = useNavigate();

  return (
    <div className="w-full font-poppins flex items-center flex-col justify-center">
      <p className="font-[600] text-[24px] md:text-[35px] xl:text-[48px] text-primary">
        Accreditation
      </p>
      <div className="w-[calc(100%_-_32px)] md:w-[calc(100%_-_64px)] xl:w-[92%] flex mt-10  flex-col xl:flex-row gap-10">
        <div className="flex gap-8 md:gap-10  991:gap-20 flex-col md:flex-row">
          <div className="w-full md:w-[50%] rounded-[15px]">
            <img src={docImg} className="h-full object-cover rounded-[15px]" />
          </div>
          <div className="w-full md:w-[50%] flex font-[400] text-[14px] md:text-[16px] text-[#5C616E] flex-col gap-8">
            <div className="w-[100%]  flex flex-col gap-2">
              {/* <p>
                The MSA-CESS is an institutional accrediting agency recognized
                by the U.S. Secretary of Education and the Council for Higher
                Education Accreditation (CHEA). Param Institute of Education has
                been accepted as a Candidate for Accreditation by the Middle
                States Association Commissions on Elementary and Secondary
                Schools (MSA-CESS). Note: The school is in a process for
                Accreditation.
              </p>
              <p>
                PTCB-Recognized Education/Training Program for Certified
                Pharmacy Technician (CPhT) PTCB-Recognized Education/Training
                Program for Certified Compounded Sterile Preparation Technician
                (CSPT)
              </p> */}
              {/* <p>
                The Param Institute of Education Career and Technical Institute is a Candidate for <a target="__blank" className="font-bold" href="https://drive.google.com/file/d/1ID7eWAThUyp5_-OhPBFutS2xz44ue4ho/view">Accreditation</a> by the Commission on Secondary Schools of the Middle States Association of Colleges and Schools, 3819-33 Chestnut Street, Suite 310, Philadelphia, PA 19104-3171 (267-284-5000) effective Date May 12 2023</p>

              <p>  PTCB-Recognized Education/Training Program for Certified Pharmacy Technician (CPhT) PTCB-Recognized Education/Training Program for Certified Compounded Sterile Preparation Technician (CSPT)
              </p> */}

              <p className="text-[#5C616E] font-[400]  mt-2 leading-[40px]">
                Now that PARAM ISNTITUTE OF EDUCATION{" "}
                <span className="font-bold">
                  is accredited by the Middle States Association,
                </span>{" "}
                we join a community of 3,200 schools in 117 countries that hold
                themselves to the highest educational standards.
              </p>
              <p className="text-[#5C616E] font-[400]  mt-2 leading-[40px]">
                PARAM ISNTITUTE OF EDUCATION has been{" "}
                <span className="font-bold">
                  accredited by the Middle States Association (MSA){" "}
                </span>
                a milestone that affirms the school meets rigorous standards and
                is committed to continuous improvement.
              </p>
              <p className="text-[#5C616E] font-[400]  mt-2 leading-[40px]">
                PARAM ISNTITUTE OF EDUCATION is Fully accredited by{" "}
                <a
                  href="https://members.msa-cess.org/membership/directory"
                  target="_blank"
                  className="underline text-blue-600"
                >
                  MSA-CESS (Commission on Secondary Schools of the Middle States
                  Association of Colleges and Schools)
                </a>{" "}
                to award certificates. The MSA-CESS is an institutional
                accrediting agency recognized by the U.S. Secretary of Education
                and the Council for Higher Education Accreditation located at
                St. Leonard’s Court 3819-33 Chestnut Street Suite 310 |
                Philadelphia PA 19104-3171 Effective Date: April 17 2026.
              </p>
            </div>
            <ul className="list-disc">
              <div className="flex flex-col pl-5 gap-4 md:gap-5">
                <li>National Health career Association (NHA)</li>
                <li>American Medical Certification Associations (AMCA)</li>
                <li>
                  Accepted Candidacy of Middle States Association Commissions on
                  Elementary and Secondary Schools (MSA-CESS)
                </li>
                <li>Pharmacy Technician Certification Board (PTCB)</li>
              </div>
            </ul>
            <div className="hidden xl:flex md:grid-cols-4 w-[92%] justify-between py-2 items-center">
              <a href="https://www.nhanow.com/" target="_blank">
                {" "}
                <img src={nha} />
              </a>
              <a href="https://www.amcaexams.com/" target="_blank">
                {" "}
                <img src={aamca} />
              </a>
              <a href="https://msa-cess.org/" target="_blank">
                {" "}
                <img src={msa} />
              </a>
              <a href="https://www.ptcb.org/" target="_blank">
                <img src={ptc} />
              </a>
            </div>
            <div className="hidden xl:block">
              <button
                className="orangeHoverButton"
                onClick={() => {
                  navigation("accreditation");
                }}
              >
                Learn More
              </button>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 991:grid-cols-4 gap-10 991:gap-0 991:grid-flow-col xl:hidden  py-2 items-center">
          <a
            href="https://www.nhanow.com/"
            target="_blank"
            className="flex justify-center"
          >
            {" "}
            <img src={nha} />
          </a>
          <a
            href="https://www.amcaexams.com/"
            target="_blank"
            className="flex justify-center"
          >
            {" "}
            <img src={aamca} />
          </a>
          <a
            href="https://msa-cess.org/"
            target="_blank"
            className="flex justify-center"
          >
            {" "}
            <img src={msa} />
          </a>
          <a
            href="https://www.ptcb.org/"
            target="_blank"
            className="flex justify-center"
          >
            <img src={ptc} />
          </a>
          {/* <div className='flex'>
                        <a href='https://www.nhanow.com/' target='_blank'>  <img src={nha} /></a>
                        <a href='https://www.amcaexams.com/' target='_blank'> <img src={aamca} /></a>
                    </div>
                    <div className='flex'>
                       
                    </div> */}
        </div>
        <div className="flex xl:hidden justify-center">
          <button
            className="orangeHoverButton"
            onClick={() => {
              navigation("accreditation");
            }}
          >
            Learn More
          </button>
        </div>
      </div>
    </div>
  );
}

export default Section4;
